// extracted by mini-css-extract-plugin
export var bodySections = "_6q-8";
export var gray = "_6q-7";
export var green = "_6q-4";
export var iconContainer = "_6q-9";
export var iconWidgetContainer = "_6q-1";
export var phoneIcon = "_6q-2";
export var red = "_6q-5";
export var statusDot = "_6q-3";
export var widgetContainer = "_6q-0";
export var yellow = "_6q-6";